/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Validates and Return the cquotient namespace provided by the commerce cloud platform
	 * @returns {Object} - einsteinUtils or null
	 */

	function getEinsteinUtils() {
	    var einsteinUtils = window.CQuotient;
	    if (einsteinUtils && typeof einsteinUtils.getCQUserId === 'function' && typeof einsteinUtils.getCQCookieId === 'function') {
	        return einsteinUtils;
	    }
	    return null;
	}

	/**
	 * fills in the carousel with product tile html objects
	 * @param {string} einsteinResponse string html for product tiles
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 */
	function fillDomElement(einsteinResponse, $parentElement) {
	    var recommender = $parentElement.data('recommender');
	    var recommendedProducts = einsteinResponse[recommender].recs;
	    if (recommendedProducts && recommendedProducts.length > 0) {
	        var components = [];
	        components = recommendedProducts.map(function (recommendedProduct) {
	            var tiledefinition = {};
	            tiledefinition.model = {
	                type: 'product',
	                id: recommendedProduct.id
	            };
	            return tiledefinition;
	        });

	        var url = new URL($parentElement.data('product-load-url'));
	        url.searchParams.append('components', JSON.stringify(components));
	        // SFRA6 migration, not used but implemented for possible new features
	        url.searchParams.append('recommender', recommender);
	        $.ajax({
	            url: url.href,
	            type: 'get',
	            dataType: 'html',
	            success: function success(html) {
	                $parentElement.find('.multiple-items').html(html);
	                $('body').trigger('einsteinCarousel:setup', $parentElement);

	                // Adding events "viewReco" and "clickReco" for SFCC analytics
	                var einsteinUtils = getEinsteinUtils();
	                if (einsteinUtils) {
	                    try {
	                        var products = recommendedProducts.map(function (product) {
	                            return {
	                                id: product.id
	                            };
	                        });

	                        var params = {
	                            userId: einsteinUtils.getCQUserId(),
	                            cookieId: einsteinUtils.getCQCookieId(),
	                            ccver: '1.01',
	                            products: products
	                        };

	                        einsteinUtils.sendActivity(einsteinUtils.clientId, 'viewReco', params);

	                        $parentElement.find('.product-tile a').on('click', function () {
	                            try {
	                                einsteinUtils.sendActivity(einsteinUtils.clientId, 'clickReco', params);
	                            } catch (clickError) {
	                                console.error('Error sending clickReco activity:', clickError);
	                            }
	                        });
	                    } catch (viewError) {
	                        console.error('Error sending viewReco activity:', viewError);
	                    }
	                }
	            },
	            error: function error() {
	                $parentElement.spinner().stop();
	            }
	        });
	    }
	}

	/**
	 * Processes a recommendation tile, with an already initialized category specific anchors array
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 * @param {Object} einsteinUtils cquotient object
	 * @param {Array} anchorsArray array of objects representing anchors
	 */
	function processRecommendationsTile($parentElement, einsteinUtils, anchorsArray) {
	    var recommender = $parentElement.data('recommender');

	    var params = {
	        userId: einsteinUtils.getCQUserId(),
	        cookieId: einsteinUtils.getCQCookieId(),
	        ccver: '1.01'
	    };

	    if (anchorsArray) {
	        params.anchors = anchorsArray;
	    }

	    /**
	    * Processes a recommendation responses
	    * @param {Object} einsteinResponse cquotient object
	    */
	    function recommendationsReceived(einsteinResponse) {
	        fillDomElement(einsteinResponse, $parentElement);
	        $parentElement.spinner().stop();
	    }

	    if (einsteinUtils.getRecs) {
	        einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
	    } else {
	        einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
	        einsteinUtils.widgets.push({
	            recommenderName: recommender,
	            parameters: params,
	            callback: recommendationsReceived
	        });
	    }
	}

	/**
	 * Processes a recommendation tile, with an already initialized product specific anchors array
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 * @returns {Array} - containing an anchor object
	 */
	function createProductAnchor($parentElement) {
	    return [{
	        id: $parentElement.data('primaryProductId'),
	        sku: $parentElement.data('secondaryProductId'),
	        type: $parentElement.data('alternativeGroupType'),
	        alt_id: $parentElement.data('alternativeGroupId')
	    }];
	}

	/**
	 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 * @returns {Array} - containing an anchor object
	 */
	function createCategoryAnchor($parentElement) {
	    return [{ id: $parentElement.data('categoryId') }];
	}

	/**
	 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
	 * einstein engine and feeds them back to the dom element
	 */
	function loadRecommendations() {
	    var einsteinUtils = getEinsteinUtils();
	    if (einsteinUtils) {
	        var $recommendationTiles = $('.js-einstein-carousel');
	        $recommendationTiles.each(function () {
	            var $parentElement = $(this);
	            $parentElement.spinner().start();
	            if ($(this).closest('.experience-einstein-einsteinCarouselProduct').length || $(this).closest('.experience-einstein-einsteinCarouselProductLH').length) {
	                return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
	            } else if ($(this).closest('.experience-einstein-einsteinCarouselCategory').length || $(this).closest('.experience-einstein-einsteinCarouselCategoryLH').length || $(this).closest('.experience-einstein-einsteinMenuTrendingCarousel').length) {
	                return processRecommendationsTile($parentElement, einsteinUtils, createCategoryAnchor($parentElement));
	            }
	            return processRecommendationsTile($parentElement, einsteinUtils);
	        });
	    }
	}

	$(document).ready(function () {
	    // Only initialize if not already initialized
	    if (!window.einsteinInitialized) {
	        window.einsteinInitialized = true;
	        loadRecommendations();
	    }
	});

/***/ })
/******/ ]);